var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-button",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.topleft",
          modifiers: { hover: true, topleft: true },
        },
      ],
      staticClass: "px-2",
      staticStyle: { "background-color": "transparent", border: "none" },
      attrs: { title: _vm.content, variant: "light", "aria-label": "Info" },
    },
    [
      _c("i", {
        staticClass: "fa fa-info-circle fa-lg text-gray-500",
        attrs: { "aria-hidden": "true" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }